export default {
  path: "/SectionContent/Glossary",
  name: "Glossary",
  htmlContent: "glossary.html",
  headings: [],
};
